import { useOutletContext } from "react-router-dom";
import { eventStatusLabels } from "../../domain/operations";
import { platformServices } from "../../platform/platform";
import { useOperations } from "../../state/OperationsProvider";

export function EventOverview() {
  const { eventId } = useOutletContext<{ eventId: string }>();
  const { snapshot } = useOperations();
  const event = snapshot?.events.find((item) => item.id === eventId);
  if (!snapshot || !event) return null;
  const lead = snapshot.staff.find((staff) => staff.id === event.leadStaffId);

  return (
    <div className="event-overview">
      <dl className="overview-grid">
        <div><dt>Event</dt><dd>{event.name}</dd></div>
        <div><dt>Type</dt><dd>{event.type}</dd></div>
        <div><dt>Status</dt><dd>{eventStatusLabels[event.status]}</dd></div>
        <div><dt>Client</dt><dd>{event.client}</dd></div>
        <div><dt>Date</dt><dd>{event.dateRangeLabel ?? event.dateLabel}</dd></div>
        <div><dt>Location</dt><dd>{event.location ?? "—"}</dd></div>
        <div><dt>Headcount</dt><dd>{event.headcount ?? "—"}</dd></div>
        <div><dt>Service</dt><dd>{event.selectedService ?? "—"}</dd></div>
        <div><dt>FSWL lead</dt><dd>{lead?.name ?? "Unassigned"}</dd></div>
      </dl>
      {event.sourceInvoice && (
        <section className="event-source-invoice">
          <h3>Source invoice</h3>
          <dl className="overview-grid">
            <div><dt>Filename</dt><dd>{event.sourceInvoice.filename}</dd></div>
            <div><dt>Invoice #</dt><dd>{event.sourceInvoice.invoiceNumber ?? "—"}</dd></div>
            <div><dt>Issue date</dt><dd>{event.sourceInvoice.invoiceIssueDate ?? "—"}</dd></div>
            <div><dt>Imported</dt><dd>{new Date(event.sourceInvoice.importedAt).toLocaleString()}</dd></div>
          </dl>
          {event.sourceInvoice.sourceUrl && (
            <a className="text-button" href={event.sourceInvoice.sourceUrl} target="_blank" rel="noreferrer">
              Open original PDF
            </a>
          )}
        </section>
      )}
      <div className="overview-split">
        <section>
          <h3>Key Times</h3>
          <p className="muted">Service-dependent times from fixture data. The Services system is not built yet.</p>
          <ul className="key-time-list">{event.keyTimes.map((item) => <li key={item.id}><span>{item.label}</span><strong>{item.timeLabel}</strong></li>)}</ul>
        </section>
        <section>
          <h3>Contacts</h3>
          <ul className="contact-list">
            {event.contacts.map((contact) => (
              <li key={contact.id}>
                <div><strong>{contact.name}</strong><small>{contact.role}{contact.external ? " · External" : " · FSWL"}</small></div>
                {contact.phone && <button className="text-button" onClick={() => platformServices.call(contact.phone!)}>Call</button>}
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
